// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3eSbB","paramInput":"JobSimulator_paramInput__1FdYD","input":"JobSimulator_input__2ycHZ"};